module.exports = __webpack_public_path__ + "img/Appstore-Download.svg";